export const PASSWORD_MIN = 8;
export const PASSWORD_MIN_ADMIN = 12;
export const PASSWORD_MAX = 150;

export enum Source {
    PROJECTS_LAUNCH = 'projects_launch',
    CONTESTS_LAUNCH = 'contests_launch',
    SQUARESPACE_LAUNCH = 'squarespace_launch',
    LOGIN_PAGE = 'login_page',
    VISTAPRINT_SSO = 'vistaprint_sso',
}
